import { POST_SNAPSHOT } from '../constants'
import { createAction, handleActions } from 'redux-actions'
import { IgetSnapshotSuccess } from '../types'

// ACTION CREATORS
export const getSnapshot = createAction(POST_SNAPSHOT)

// REDUCERS
export default handleActions(
  {
    POST_SNAPSHOT_SUCCESS: (state, action: IgetSnapshotSuccess) => {
      // different returns for view: 1 and view: 2
      if (action.payload.view === 1) {
        return [
          sortNewSnapshots(state[0], action.payload.snapshot),
          state[1]
        ]
      }
      return [
        state[0],
        sortNewSnapshots(state[1], action.payload.snapshot)
      ]
    }
  },
  [[], []]
)

const sortNewSnapshots = (snapshots: { snapshot: string, timestamp: string }[], newSnapshot: { snapshot: string, timestamp: string }) => {
  const items = [
    ...snapshots,
    newSnapshot
  ]

  // sort the snapshots in ascending order based on the timestamps i.e. '07:00', '07:15', '07:30'
  return items.sort((a, b) => {
    // slice the first 4 letters e.getComputedStyle. 'Mon ', 'Tue ', ... and leave only numbers
    const aTime = a.timestamp.slice(4)
    const bTime = b.timestamp.slice(4)
    if (aTime < bTime) return -1
    if (aTime > bTime) return 1
    return 0
  })
}



// WEBPACK FOOTER //
// ./src/ducks/snapshot.ts